export default "__VITE_ASSET__9eba458a__"